module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@2x-2a688769f273b7819150ece4f13a4ce2.png";